import { OnInit, Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {first} from "rxjs";
import {FicheAmiService} from "../../core/services/fiche.ami.service";
import {ToastService} from "../../shared/components/toast/toast.service";
import {META_TAG} from "../../core/const/meta_tag";
import {UserService} from "../../core/user/user.service";

@Component({
  selector: 'app-contact-by-tdm',
  templateUrl: './contact-by-tdm.component.html',
  styleUrls: ['./contact-by-tdm.component.scss', '../contact/contact.component.scss']
})
export class ContactByTdmComponent implements OnInit {
  userConnected?: any = {};
  contactForm!: FormGroup;
  constructor(
    private formBuilder: FormBuilder,
    private amiService: FicheAmiService,
    private toastService: ToastService,
    private userService: UserService,
  ) {}
  ngOnInit() {
    this.userConnected = this.userService.getUser();
    this.createcontactForm();
  }

  submitFormContact() {
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    let param = this.contactForm.value;
    param.objectDemande = 'Contact by TDM'
    param.origine = 'by TDM'
    param.bytdm = true
    this.amiService
      .contact(param)
      .pipe(first())
      .subscribe(
        (response: any) => {
          this.contactForm.reset();
          this.showSuccess(
            'Votre message a bien été envoyé, nous vous remercions pour votre visite.'
          );
        },
        (error: any) => {
          this.showDanger(
            "Votre message n'est pas envoyé, veuillez réessayer plus tard."
          );
        }
      );
  }
  showSuccess(message: any) {
    this.toastService.show(message, {
      classname: 'bg-success text-light',
      delay: 5000,
    });
  }
  showDanger(dangerTpl: any) {
    this.toastService.show(dangerTpl, {
      classname: 'bg-danger text-light',
      delay: 5000,
    });
  }
  get f() {
    return this.contactForm.controls;
  }

  createcontactForm() {
    this.contactForm = this.formBuilder.group({
      nom: [this.userConnected ? this.userConnected.nom : '', Validators.required],
      prenom: [this.userConnected ? this.userConnected.prenom : '', Validators.required],
      email: [this.userConnected ? this.userConnected.usermail : '', Validators.required],
      tel: [this.userConnected ? this.userConnected.phone : '', Validators.required],
      nomAgence: [''],
      ville: [''],
      vousetes: ['', Validators.required],
      dispo: ['', Validators.required],
      rgpd: [false, Validators.requiredTrue],
      objectDemande: ['Contact by TDM'],
      message: ['', Validators.required],
      bytdm: true,
    });
  }
}
